<script>
	//import { cardsFilter } from '$lib/stores';
	//import BgImg from '../assets/st-card-bg.jpg';
    import { isTouchDevice } from '../ui';
	import { getSuitColor } from './helpers';
	import "./shared.css";

	export let id;
	export let c;
	export let handleClick;

	let colorText = '';
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
<!----><div
	class="card flex-div" style="--suit-color: {getSuitColor(c && c.suits && c.suits.length > 0 ? c.suits[0] : 'none')};"
	on:click={e => { if(!isTouchDevice()) handleClick(c);} } on:touchstart={e => { if(isTouchDevice()) handleClick(c);} }
>
	<img class="card-bg" src="assets/st-card-bg.jpg" alt="" />
	<slot />
</div>

<style lang="scss">
	:global(.flex-div div) {
		display: flex;
		user-select: none;
	}
	.card {
		opacity: var(--opacity);
		position: relative;
		box-sizing: border-box;
		flex-direction: column;
		background-color:lab(from var(--suit-color) calc(l* 2) a b);
		font-size: calc(var(--height) / 25.0625); // added for default 16px
		/*height: 401px;
		width: 287px;*/
		display: flex;
		width: var(--width);
		height: var(--height);
		//background-color: white;
		border-radius: calc(var(--width) / 22.0769); //13px;
		border: 1px solid black;
		overflow: hidden;
		transform-style: preserve-3d;
		//transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
		//-webkit-transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
		color: black;
	}
	@media print {
		.card {
			border-radius: 0;
			display: var(--print-display);
		}
	}
	.card-bg {
		display: none;
		position: absolute;
		width: 100%;
		top: 0;
		z-index: -10;
	}
</style>
